import { MediumTypeModel } from '../kymw1300/vo/medium-type.model';
import { KYMW1318Component } from './kymw1318.component';

/**
 * 受注コード指定選定解除画面の値を管理するクラス
 *
 * @export KYMW1318Model
 * @class KYMW1318Model
 */
export class KYMW1318Model {
  kymw1318Component: KYMW1318Component;
  public orderCode = '';
  public pCode = '';
  public target = '';
  public orderCodeList: Array<string> = [];
  public displayList: Array<any> = [];
  public displayMap = new Object();
  public mediumType = '';
  public mediumTypeList: Array<MediumTypeModel> = [];
}
